import { Component, Input } from '@angular/core';

@Component({
  selector: 'acan-form-shell',
  templateUrl: './acan-form-shell.component.html',
  styleUrls: ['./acan-form-shell.component.scss'],
  standalone: false,
})
export class AcanFormShellComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() backLink?: string[];
  /** When true, strips page chrome (negative margin / viewport min-height) for dialogs */
  @Input() dialog = false;
  @Input() showHeader = true;
  @Input() showFooter = true;
}
